import {ProcessExecutionType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ProcessTaskSchemaGraphQL} from '../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';

/**
 * Checks if a task schema is a flowchart task schema.
 *
 * TODO: Enable clients of workflows platform to define if their taskDefinitions are a "flowchart" type
 * to be used with the flowchart editor.
 */
export function isFlowchartTaskSchema(taskSchema: ProcessTaskSchemaGraphQL): boolean {
  return taskSchema.executionType === ProcessExecutionType.FLOWCHART;
}
